import { createEnrichmentIsland } from "@/utils/islands";
import "./employees-list.css";

const getParentElemet = (
    startElm: HTMLElement,
    parentClassName: string,
): HTMLElement | null => {
    let counter = 0;
    let elm: HTMLElement | null = startElm;
    do {
        elm = elm.parentElement;
        if (elm && elm.classList.contains(parentClassName)) {
            return elm;
        }
    } while (elm && ++counter < 10);
    return null;
};

const handleButtonClick = (
    buttonElm: HTMLAnchorElement,
    buttonClickEvent: Event,
) => {
    buttonClickEvent.preventDefault();
    const targetUrl = buttonElm.href;

    const wasExpanded = buttonElm.getAttribute("aria-expanded") === "true";
    buttonElm.setAttribute("aria-expanded", (!wasExpanded).toString());
    const parentElm = getParentElemet(buttonElm, "employee-contact-card");
    parentElm?.classList.toggle("expanded", !wasExpanded);
    // Argh, annoying grid requirements, I would really like to handle this in css
    parentElm?.classList.toggle("lg:col-span-3", !wasExpanded);
    parentElm?.classList.toggle("md:col-span-2", !wasExpanded);

    // change url in link and history
    if (!wasExpanded) {
        const backUrl = document.location.href;
        buttonElm.setAttribute("data-original", targetUrl);
        buttonElm.setAttribute("data-back", backUrl);
        history.pushState(null, "", targetUrl);
        buttonElm.setAttribute("href", backUrl);
    } else {
        const backUrl = buttonElm.getAttribute("data-back");
        const originalUrl = buttonElm.getAttribute("data-original");
        history.pushState(null, "", backUrl ?? "");
        buttonElm.setAttribute("href", originalUrl ?? "");
    }

    // If there is a details rendering on the page, then hide it
    document
        .querySelector(".employee-detailed-container.component")
        ?.classList.toggle("hidden", true);
};

const handleDepartmentFilter = (btn: HTMLButtonElement) => {
    btn.addEventListener("click", () => {
        document
            .querySelectorAll(".department-filter")
            .forEach((b) => b.setAttribute("aria-pressed", "false"));
        btn.setAttribute("aria-pressed", "true");
        const selected = btn.getAttribute("data-department");
        document.querySelectorAll(".employee-contact-card").forEach((card) => {
            const cardElm = card as HTMLElement;
            const toShow =
                selected === "Alle" ||
                cardElm.getAttribute("data-department") === selected;
            cardElm.classList.toggle("hidden", !toShow);
        });
    });
};

const handleEmployeeSort = (sortSelect: HTMLSelectElement) => {
    sortSelect.addEventListener("change", () => {
        const sortBy = sortSelect.value;
        const container = document.querySelector(".employee-contact-list");
        if (!container) return;
        const cards = Array.from(
            container.querySelectorAll(".employee-contact-card"),
        );
        cards.sort((a, b) => {
            const aName =
                a.querySelector(".employee-name")?.textContent?.trim() ?? "";
            const bName =
                b.querySelector(".employee-name")?.textContent?.trim() ?? "";
            const aDept = a.getAttribute("data-department") ?? "";
            const bDept = b.getAttribute("data-department") ?? "";
            let result = 0;
            if (sortBy === "name-asc") {
                result = aName.localeCompare(bName);
            } else if (sortBy === "name-desc") {
                result = bName.localeCompare(aName);
            } else if (sortBy === "department-asc") {
                result = aDept.localeCompare(bDept);
            } else if (sortBy === "department-desc") {
                result = bDept.localeCompare(aDept);
            }
            return result;
        });
        cards.forEach((card) => container.appendChild(card));
    });
};

const initEmployeeContactCard = (): void => {
    createEnrichmentIsland(".department-filter", (elm: Element) =>
        handleDepartmentFilter(elm as HTMLButtonElement),
    );
    createEnrichmentIsland("#employee-sort", (elm: Element) =>
        handleEmployeeSort(elm as HTMLSelectElement),
    );
    createEnrichmentIsland(".employee-contact-card a", (elm: Element) => {
        elm.addEventListener("click", (evt) =>
            handleButtonClick(elm as HTMLAnchorElement, evt),
        );
    });
};
export default initEmployeeContactCard;
